import { element } from 'protractor';
import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { NgForm, Validators } from '@angular/forms';
import { map, takeUntil } from 'rxjs/operators';
import moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { Subject, Subscription } from 'rxjs';
import { ImagilityBaseResponse, ReferenceLibrary, acceptedFileTypes } from 'app-models';
import { WorkDetails } from 'src/app/data/models/work-experience.model';
import { ApiServicesService } from 'src/app/modules/beneficiary/services/api-services.service';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { AuthenticationService } from 'authentication';
import { DirtyFormGuard } from 'dirty-check-store';
import { environment } from 'environment-configurations';
import { ReferenceLibraryService } from 'reference-library';
import { BeneficiaryQuestionnaireService } from 'src/app/modules/beneficiary-questionnaire/beneficiary-questionnaire.service';
import { CacheCountryService } from 'src/app/services/cacheCountries.service';
import { UnsubscribeSubcriptionService } from 'src/app/services/unsubscribe-subcription.service';
import { UploadDocumentService } from 'src/app/services/upload-document.service';
import { DependentProfileDataService } from '../../services/dependent-profile-data.service';
import { UtilityServiceService } from '../../services/utility-service.service';
import { MatTableDataSource } from '@angular/material/table';
import { ConfirmationModalComponent } from 'src/app/modules/shared/modal/confirmation-modal/confirmation-modal.component';
import { CustomErrorToastComponent } from 'custom-error-toast';
@Component({
  selector: 'app-experience-details',
  templateUrl: './experience-details.component.html',
  styleUrls: ['./experience-details.component.scss']
})
export class ExperienceDetailsComponent implements OnInit {

  beneficiaryWorkDetails = new WorkDetails({});
  maxDate: Date;
  viewMode: boolean = false;
  payload: any = null;
  beneficiaryId: number;
  familyId: any;
  isExternalEmployeeId:string;
  isLocked:boolean=false;
  onlyFormBuilder;
  listCountryOfficePhone: any[] = [];
  isFBUser: boolean;
  phoneTypeList: ReferenceLibrary[];
  currencyTypeList: ReferenceLibrary[];
  listEmploymentType: ReferenceLibrary[];
  listCountry: [];
  listStates: any[];
  dependentIdSubscription: Subscription;
  observableSubscription$ = new Subject();
  dependentId: any;
  beneficiaryType: any;  
  hasID: boolean = false;
  experienceFileUploadConfigurations = {
    inputMultipleFlag: true,
    fileType: acceptedFileTypes,
    isFileListRequired: true,
    categoryName: 'BENWEDOC',
    entityId: 0,
    fileCategory: '',
    listUploadedFiles: [],
    documentTypeRequired: true,
    docummentTypeCode: 'BENWEDOC',
    useCase: 'beneficiary',
    useCaseId: 0,
    useEntityId: false,
    isDeleteEnabled: this.viewMode ? false : true,
    isUploadEnabled: this.viewMode ? false : true,
    familyId: null
  };

  displayedColumns: string[] = ['companyName', 'designation', 'startDate', 'endDate', 'id'];    
  dataSource : any[] = [];

  @ViewChild('benExpForm') benExpForm: NgForm;

  constructor(
    private apiService: ApiServicesService,
    private cacheCountryService: CacheCountryService,
    private authenticationService: AuthenticationService,
    private uploadDocumentService: UploadDocumentService,
    private referenceLibraryService: ReferenceLibraryService,
    private utilityService: UtilityServiceService,
    private toastr: ToastrService,
    private changeDetector: ChangeDetectorRef,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    protected store: Store<any>,
    private dependentProfileDataService: DependentProfileDataService,
    private dirtyFormGuard: DirtyFormGuard,
    private benServ: BeneficiaryQuestionnaireService,
    private unsubscribeSubscriptionService: UnsubscribeSubcriptionService
  ) {
    this.beneficiaryId = (sessionStorage.getItem('listBeneficiaryId')) ? parseInt(sessionStorage.getItem('listBeneficiaryId')) : (this.authenticationService.currentUserValue ? this.authenticationService.currentUserValue['beneficiaryId'] : sessionStorage.getItem('beneficiaryId'));
    this.listCountry = [];
    this.listStates = [];    
    this.maxDate = new Date();
    this.isExternalEmployeeId = sessionStorage.getItem('_isExternalEmployeeId');
    if(this.isExternalEmployeeId){
      this.isLocked=true;
    }
    this.isFBUser = 'isFBUser' in sessionStorage ? sessionStorage.getItem('isFBUser') === 'true' : false;
   }

  ngOnInit(): void {
    
    if(this.onlyFormBuilder === 'FB') {
      this.beneficiaryId = (sessionStorage.getItem('FbEmployeeId')) ? parseInt(sessionStorage.getItem('FbEmployeeId')) : 0;
    } else {
      this.beneficiaryId = (sessionStorage.getItem('listBeneficiaryId')) ? parseInt(sessionStorage.getItem('listBeneficiaryId')) : (this.authenticationService.currentUserValue ? this.authenticationService.currentUserValue['beneficiaryId'] : sessionStorage.getItem('beneficiaryId'));
    }

    this.referenceLibraryService.getReferenceDataWithoutAuthentication('PHON').pipe(takeUntil(this.observableSubscription$)).subscribe((response: ReferenceLibrary[]) => {
      this.phoneTypeList = response;
    });

    this.dependentIdSubscription = this.dependentProfileDataService.dependentProfileSubject.pipe(takeUntil(this.observableSubscription$)).subscribe((selectedBeneObj:any) => {
      this.familyId = selectedBeneObj.dependentId;
      this.beneficiaryType = selectedBeneObj.beneficiaryType;    
      this.getUpolodedFiles();
    });

    this.getBeneficiaryWorkDetails();
    this.dependentProfileDataService.onLifeStorySubTabs.next();   
    
    this.uploadDocumentService.uploaded$.pipe(takeUntil(this.observableSubscription$)).subscribe(status => {
      if (status === true) {
        this.getBeneficiaryWorkDetails();
      }
    });    

    if (this.beneficiaryId) {
      this.experienceFileUploadConfigurations.useCaseId = this.beneficiaryId;
      this.experienceFileUploadConfigurations.familyId = this.familyId;
      this.experienceFileUploadConfigurations = Object.assign({}, this.experienceFileUploadConfigurations);
      this.getBeneficiaryWorkDetails();
    }

  }

  fileUploadSuccess() {
    this.getBeneficiaryWorkDetails(); // Relaod main table
  }

  hasValues(obj: any): boolean {
    for (const key in obj) {
      if (obj.hasOwnProperty(key) && obj[key] !== null && obj[key] !== undefined) {
        return true;
      }
    }
    return false;
  }

  saveEmployment(benExpForm: NgForm) {    
    if (this.hasValues(benExpForm.form.value)) {
      this.payload = this.constructPayload(this.beneficiaryWorkDetails);
      this.apiService.saveBeneficiaryDetails(this.beneficiaryId, 'experience', this.payload, this.familyId).pipe(takeUntil(this.observableSubscription$)).subscribe((response: ImagilityBaseResponse) => {
      if (response.status === 200) {
        benExpForm.reset(benExpForm.value)
        this.toastr.success(response.message, 'Success');
        this.payload.id = response.data['workExpDetailsReq'][0]['id'];
        this.experienceFileUploadConfigurations.entityId = this.payload.id;
        this.experienceFileUploadConfigurations.useCaseId = this.beneficiaryId;
        this.experienceFileUploadConfigurations = Object.assign({}, this.experienceFileUploadConfigurations);
        this.hasID = true;        
        //this.resetForm();
        this.getBeneficiaryWorkDetails();        
      }
    });
    } else {
      CustomErrorToastComponent.showErrorToast(this.toastr, 'Unable to update experience details.');
    }    
  }

  constructPayload(input) {
    this.payload = {
      'workExpDetailsReq': [{
        id: input.id || null,
        addressLine1: input.addressLine1 || null,
        addressLine2: input.addressLine2 || null,
        city: input.city || null,
        companyName: input.companyName || null,
        scheduledWeeklyHours:input.scheduledWeeklyHours || null,
        employmentType: input.employmentType ? input.employmentType : null,
        country: input.countryCode || null,
        countryCode: input.countryCode || null,
        currency: input.currency || null,
        designation: input.designation || null,
        isCurrentRole: input.isCurrentRole ? 1 : 0,
        mobileCountryCode: null,
        mobileNo: null,
        officeCountryCode: input.officeCountryCode ? input.officeCountryCode : null,
        officeNo: input.officeNo || null,
        salary: parseInt(input.salary) || null,
        startDate: moment(input.startDate).format('YYYY-MM-DD') || null,
        endDate: input.isCurrentRole ? null : moment(input.endDate).format('YYYY-MM-DD') || null,
        stateProvinceCode: input.stateProvinceCode || null,
        stateProvinceName: input.stateProvinceCode && this.listStates && this.listStates.length > 0 ?
          this.listStates.find((x: any) => x.stateProvinceCode === input.stateProvinceCode).stateProvinceName :
          (input.stateProvinceName ? input.stateProvinceName : null),
        workExpDetailId: input.id || null, //input.workExpDetailId,
        zipCode: input.zipCode || null,
        duty: input.duty || null,
        subDutyDescription: input.subDutyDescription || null,
        skillName: input.skillName || null,
        jobDuties: input.jobDuties || [],
        tools: input.tools || [],
        clients: input.clients || []
      }],
      isSaveAsDraft:false
    };
    return this.payload;
  }

  editExperience(element){

    this.beneficiaryWorkDetails = {
      id: element.id,
      addressLine1: element.addressLine1,
      addressLine2: element.addressLine2,
      city: element.city,
      companyName: element.companyName,
      scheduledWeeklyHours:element.scheduledWeeklyHours,
      employmentType: element.employmentType ? element.employmentType.code : null,
      country: element.countryCode,
      countryCode: element.countryCode,
      currency: element.currency,
      designation: element.designation,
      isCurrentRole: element.isCurrentRole == 1 ? true : false,
      mobileCountryCode: null,
      mobileNo: null,
      officeCountryCode: element.officeCountryCode && element.officeCountryCode.countryCode ? element.officeCountryCode.countryCode : '',
      officeNo: element.officeNo,
      salary: element.salary,
      startDate: moment(element.startDate).toISOString(),
      endDate: element.isCurrentRole == 1 ? null : moment(element.endDate).toISOString(),
      stateProvinceCode: element.stateProvinceCode,
      stateProvinceName: element.stateProvinceCode,
      workExpDetailId: element.id,
      zipCode: element.zipCode,
      duty: element.duty,
      subDutyDescription: element.subDutyDescription,
      skillName: element.skillName,
      jobDuties: element.jobDuties,
      tools: element.tools,
      clients: element.clients,
      documentList: element.documents
    };
    if (element.id) {        
      this.experienceFileUploadConfigurations.entityId = element.id;
      this.experienceFileUploadConfigurations.useCaseId = this.beneficiaryId;
      this.experienceFileUploadConfigurations.familyId = this.familyId ? this.familyId : null;        
      this.experienceFileUploadConfigurations.listUploadedFiles = element.documents ? element.documents : [];
      this.experienceFileUploadConfigurations = Object.assign({}, this.experienceFileUploadConfigurations);      
      this.hasID = true;
    }

    this.apiService.getStates(element.countryCode).pipe(takeUntil(this.observableSubscription$)).subscribe((states: []) => {
      this.listStates = states;

      this.beneficiaryWorkDetails.stateProvinceName = element.stateProvinceCode ?
      this.listStates.find((x: any) => x.stateProvinceCode === element.stateProvinceCode).stateProvinceName :
      (element.stateProvinceName ? element.stateProvinceName : null)
    
    });
  }

  deleteExperience(element){
    const title = 'Confirm';
    const message = 'Do you wish to Delete the File?';
    if (element) {
      this.dialogueInitializer(event, title, message).afterClosed().subscribe(result => {        
        if (result) {
          this.confirmDelete(element);
        }
      })
    }
  }

  confirmDelete(element){
    this.apiService.deleteBeneExperience(this.beneficiaryId, element.id, this.familyId).pipe(takeUntil(this.observableSubscription$)).subscribe((data: ImagilityBaseResponse) => {
      if (data.status === 200) { 
        this.experienceFileUploadConfigurations.entityId = 0;
        this.toastr.success(data.message, 'Success');
        this.resetForm();
        this.getBeneficiaryWorkDetails();
      }
    });
  }

  dialogueInitializer(event, title: string, message: string) {
    const cordinates: MouseEventInit = event;
    const dialogRef = this.dialog.open(ConfirmationModalComponent, {
      width: '400px',
      data: {
        update: { title, message },
        buttons: ['Cancel', 'Delete']
      }
    });
    return dialogRef;
  }

  getBeneficiaryWorkDetails() {   
    this.apiService.getBeneficiaryDetails(this.beneficiaryId, 'experience', this.familyId).pipe(takeUntil(this.observableSubscription$)).subscribe((beneficiary: WorkDetails[]) => {
      this.dataSource = beneficiary;     
    });
  }

  getUpolodedFiles() {
    this.uploadDocumentService.genericGetUploadDocument(this.experienceFileUploadConfigurations.useCase, this.experienceFileUploadConfigurations.useCaseId, this.experienceFileUploadConfigurations.categoryName, this.experienceFileUploadConfigurations.entityId, this.experienceFileUploadConfigurations.useEntityId, this.experienceFileUploadConfigurations.familyId).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
      if (response['status'] === 200) {
        this.experienceFileUploadConfigurations.listUploadedFiles = response['data'];
        this.experienceFileUploadConfigurations = Object.assign({}, this.experienceFileUploadConfigurations);
      }
      else {
        this.experienceFileUploadConfigurations.listUploadedFiles = [];
        this.experienceFileUploadConfigurations = Object.assign({}, this.experienceFileUploadConfigurations);
      }
    });

  }

  resetForm() {    
    // this.experienceFileUploadConfigurations.listUploadedFiles = [];
    // this.experienceFileUploadConfigurations = Object.assign({}, this.experienceFileUploadConfigurations);
    this.beneficiaryWorkDetails = new WorkDetails({});    
  }

}
